import { wallets } from "../../rbac-consts";
import Can from "../can/Can";
import React, { useContext } from "react";
import { AppContext } from "../../App";

import { default as ClientWalletsTabsContainer } from "./client/WalletsTabsContainer";

const WalletsWrapper = () => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={wallets.USER}
        yes={() => (
          <ClientWalletsTabsContainer />
        )}
      />
    </>
  );
};

export default WalletsWrapper;